import React from 'react';
import {ReportesNew} from "../components/reportes/ReportesNew";

const ReportesPage = () => (
    <>
        <ReportesNew/>
    </>
);

export default ReportesPage;